import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { App, Typography, Space, Button, Skeleton } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

import AdminTemplate from '../../layout/AdminTemplate';
import NotificationComponent from './Notifications';
import { useEvent } from '../events/hooks/useEvent';
import { decreaseNotificationCount, increaseNotificationCount } from '../../actions/prerenderUserActions';
import { useMarkAsReadMutation, useGetNotificationQuery } from './NotificationsApiSlice';

const META_TAGS = {
  title: 'Notifications - Prerender.io',
};

function NotificationDetailsPage() {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const { id } = useParams();
  const { track } = useEvent();
  const dispatch = useDispatch();
  const notificationQueryResult = useGetNotificationQuery(id);
  const [markAsReadMutation] = useMarkAsReadMutation();

  const markAsRead = (notificationId) => {
    // Optimistically decrement, then roll back if the request fails so the unread
    // badge can't drift permanently out of sync.
    dispatch(decreaseNotificationCount(1));
    markAsReadMutation([notificationId])
      .unwrap()
      .catch(() => dispatch(increaseNotificationCount(1)));
  };

  React.useEffect(() => {
    if (notificationQueryResult.isSuccess && notificationQueryResult.data) {
      track('Notification viewed', { notificationId: notificationQueryResult.data.id });
      if (!notificationQueryResult.data.seenAt) markAsRead(notificationQueryResult.data.id);
    } else if (notificationQueryResult.isError) {
      message.error('Failed to fetch notification');
    }
  }, [notificationQueryResult.isSuccess, notificationQueryResult.isError]);

  return (
    <AdminTemplate metaTags={META_TAGS}>
      <Space direction="vertical" size="large">
        <Button icon={<CloseOutlined />} onClick={() => navigate('..')}>
          Close
        </Button>
        <Typography.Title level={2}>Notifications Center</Typography.Title>
        <Skeleton loading={notificationQueryResult.isFetching} active>
          {notificationQueryResult.data ? (
            <NotificationComponent notification={notificationQueryResult.data} />
          ) : (
            !notificationQueryResult.isFetching && (
              <Typography.Paragraph>Notification not found.</Typography.Paragraph>
            )
          )}
        </Skeleton>
      </Space>
    </AdminTemplate>
  );
}

export default NotificationDetailsPage;
